"use client";

import { AuthGate } from "@/components/auth-gate";
import PageLoaderOverlay from "@/components/page-loader-overlay";

export default function Layout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AuthGate
      redirectBase="/register"
      loadingFallback={<PageLoaderOverlay message="Loading design page..." opacity="dark" />}
    >
      <div>{children}</div>
    </AuthGate>
  );
}
